import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/green-discuss.svg';
const GreenDiscuss = () => React.createElement(IconSvg, null);
export default GreenDiscuss;
